module.exports = __webpack_public_path__ + "img/qrCode.e3f3d4dc.jpg";